import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UserSearch from './UserSearch';
import './Navbar.css';

function Navbar({ onFollowChange }) {
  const { user, isAnonymous } = useAuth();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          Socify
        </Link>

        <UserSearch onFollowChange={onFollowChange} />

        <div className="navbar-menu">
          <Link to="/" className="navbar-item">Feed</Link>
          {user?.userId && (
            <Link to={`/profile/${user.userId}`} className="navbar-item">Profile</Link>
          )}
          <Link to="/favorites" className="navbar-item">Favorites</Link>
          <Link to="/watchlist" className="navbar-item">Watchlist</Link>
          <Link to="/communities" className="navbar-item">Communities</Link>
          <Link to="/points" className="navbar-item">Points</Link>
          <span className="navbar-item" style={{ opacity: 0.75 }}>
            {isAnonymous ? 'Guest' : (user?.username || 'User')}
          </span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
